import Vue from 'vue'

const state = Vue.observable({
    ifSupportWebp: false
})

const mutations = {
    setIfSupportWebp(support) {
        state.ifSupportWebp = support
    }
}

export default {
    state,
    mutations
}
